import React from 'react'
import Container from '../components/Container'
import Login from '../components/Login'
import Profile from '../components/Profile'
import PrivateRoute from '../components/PrivateRoute'
import PostVisibilityPrivate from '../templates/postvisibilityprivate'
import { Router } from '@reach/router'
import styled from '@emotion/styled'
import { graphql } from 'gatsby'

const App = ({ data, previousLocation, location }) => {
  const App = styled.div``
  const posts = data.allContentfulPost.edges

  return (
    <App>
      <Container>
        <Router>
          <Login
            path="/app/"
            data={posts}
            previousLocation={previousLocation}
            location={location}
          />
          <PrivateRoute
            path="/app/profile/"
            component={PostVisibilityPrivate}
            data={posts}
          />
        </Router>
      </Container>
    </App>
  )
}

export default App

// this version there is no projectModelFile
export const appQuery = graphql`
  query appQuery {
    allContentfulPost(
      sort: { fields: [publishDate], order: DESC }
      filter: { visibilityPrivate: { eq: true } }
    ) {
      edges {
        node {
          password
          visibilityPrivate
          title
          publishDate(formatString: "MMMM DD, YYYY")
          slug
          tags {
            slug
          }
          fullPost
          id
          sections {
            __typename
            ... on ContentfulPostTitle {
              id
              title
            }
            ... on ContentfulPostHero {
              id
              heroImage {
                title
                fluid(maxWidth: 1800) {
                  ...GatsbyContentfulFluid_withWebp
                }
              }
              heroVideo {
                file {
                  url
                }
                description
                title
              }
              hoverMedia {
                file {
                  url
                }
                description
                title
              }
              hoverDescription {
                childMarkdownRemark {
                  timeToRead
                  html
                }
              }
            }
            ... on ContentfulPostQuote {
              id
              quoteTitle
              quotePerson
              quote {
                quote
                childMarkdownRemark {
                  html
                }
              }
            }
            ... on ContentfulPostImageGallery {
              id
              title
              imageGallery {
                file {
                  fileName
                  url
                }
                fluid(maxWidth: 1000) {
                  ...GatsbyContentfulFluid_withWebp
                }
              }
            }
            ... on ContentfulPostBody {
              id
              bodyTitle
              bodyParagraph {
                bodyParagraph
                childMarkdownRemark {
                  timeToRead
                  html
                  excerpt(pruneLength: 80)
                }
              }
            }
            ... on ContentfulPostAbstract {
              id
              abstract {
                childMarkdownRemark {
                  timeToRead
                  html
                  excerpt(pruneLength: 320)
                }
              }
              paragraph {
                childMarkdownRemark {
                  timeToRead
                  html
                  excerpt(pruneLength: 320)
                }
              }
            }
            ... on ContentfulPostResults {
              id
              metric1Result
              metric1Title
              metric2Result
              metric2Title
              metric3Result
              metric3Title
            }
            ... on ContentfulPostDownload {
              id
              title
              download {
                file {
                  url
                  fileName
                }
              }
            }
          }
          metaDescription {
            internal {
              content
            }
          }
        }
      }
    }
    allContentfulHero {
      nodes {
        heroGallery {
          fluid(maxWidth: 1800) {
            ...GatsbyContentfulFluid_withWebp
          }
          file {
            url
          }
          title
          description
        }
        description {
          description
          childMarkdownRemark {
            html
          }
        }
        rightDescription {
          rightDescription
          childMarkdownRemark {
            html
          }
        }
        title
      }
    }

    allContentfulTag {
      nodes {
        slug
        title
      }
    }
    allContentfulService(sort: { fields: [date], order: DESC }) {
      edges {
        node {
          title
          id
          date(formatString: "MMMM DD, YYYY")
          media {
            fluid(maxWidth: 800) {
              ...GatsbyContentfulFluid_withWebp
            }
            file {
              url
            }
            description
            title
          }
          headline
          description {
            description
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
    allContentfulClients {
      edges {
        node {
          title
          clientLogos {
            id
            fluid {
              ...GatsbyContentfulFluid_noBase64
            }
          }
        }
      }
    }
  }
`
